import axios from '@/libs/axios'

const directions = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get('/org-directions/', { params: queryParams })
    .then(response => {
      commit('DIRECTIONS', response.data.results)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const add = (ctx, data) => new Promise((resolve, reject) => {
  axios.post('/apply-document/org_create_apply_doc/', data)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})

const update = (ctx, data) => new Promise((resolve, reject) => {
  axios.put(`/apply-document/${data.id}/org_update_apply_doc/`, data)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})
const orgUpdateApplyDoc = (ctx, data) => new Promise((resolve, reject) => {
  axios.patch(`/apply-document/${data.id}/org_update_apply_doc/`, data)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})

const list = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get('/apply-document/org_students/', { params: queryParams })
    .then(response => {
      commit('LIST', response.data.results)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const changeState = (ctx, data) => axios.patch(`/apply-document/${data.id}/change_state/`, data)
const advisorStudents = (_, queryParams) => axios.get('/apply-document/advisor_students/', { params: queryParams })

export default {
  list,
  directions,
  add,
  update,
  orgUpdateApplyDoc,
  advisorStudents,
  changeState,
}
